import React from 'react'

interface BookProps {
  title: string
  imageUrl: string
  bookUrl: string
  price: number | null
  currency: string | null
  bookIsAvailable: boolean
  rating?: number
  reviewCount?: number
  description?: string
}

export const BookJsonLd: React.FC<BookProps> = ({
  title,
  imageUrl,
  bookUrl,
  price,
  currency,
  bookIsAvailable,
  rating,
  reviewCount,
  description
}) => {
  const structuredData = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: title,
    image: imageUrl.includes('http') ? imageUrl : `https:${imageUrl}`,
    description,
    offers: {
      '@type': 'Offer',
      availability: bookIsAvailable ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock',
      price: price?.toFixed(1) || undefined,
      priceCurrency: currency || undefined,
      url: bookUrl,
      itemCondition: 'https://schema.org/UsedCondition'
    },
    ...(rating &&
      reviewCount && {
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: rating.toFixed(1),
          reviewCount: reviewCount.toString()
        }
      })
  }

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
}
